import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center mb-6" }

import { ref, onMounted, onBeforeUnmount } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalSearchDialog',
  setup(__props) {

const modelValue = ref<boolean>()
const searchQuery = ref('')

function close() {
    modelValue.value = false
    searchQuery.value = ''
}

function onKeydown(e: KeyboardEvent) {
    if (e.key === 'Escape') {
        close()
    }
}

onMounted(() => {
    window.addEventListener('keydown', onKeydown)
})

onBeforeUnmount(() => {
    window.removeEventListener('keydown', onKeydown)
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue).value = $event)),
    width: "860",
    transition: "fade-transition"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "pa-6 rounded-xl" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_icon, { class: "mr-3" }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("mdi-magnify")
              ])),
              _: 1
            }),
            _createVNode(_component_v_text_field, {
              modelValue: searchQuery.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
              class: "flex-grow-1",
              placeholder: "Search...",
              variant: "underlined",
              "hide-details": ""
            }, null, 8, ["modelValue"]),
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "ml-3 text-caption text-medium-emphasis" }, "[esc]", -1))
          ]),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "6",
                sm: "3"
              }, {
                default: _withCtx(() => [
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-caption text-medium-emphasis font-weight-bold mb-2" }, "POPULAR SEARCHES", -1)),
                  _createVNode(_component_v_list, { density: "compact" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, {
                        title: "Analytics",
                        "prepend-icon": "mdi-chart-line"
                      }),
                      _createVNode(_component_v_list_item, {
                        title: "CRM",
                        "prepend-icon": "mdi-timer-outline"
                      }),
                      _createVNode(_component_v_list_item, {
                        title: "eCommerce",
                        "prepend-icon": "mdi-cart-outline"
                      }),
                      _createVNode(_component_v_list_item, {
                        title: "Logistics",
                        "prepend-icon": "mdi-truck-outline"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                sm: "3"
              }, {
                default: _withCtx(() => [
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-caption text-medium-emphasis font-weight-bold mb-2" }, "APPS & PAGES", -1)),
                  _createVNode(_component_v_list, { density: "compact" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, {
                        title: "Calendar",
                        "prepend-icon": "mdi-calendar-outline"
                      }),
                      _createVNode(_component_v_list_item, {
                        title: "Roles & Permissions",
                        "prepend-icon": "mdi-shield-account"
                      }),
                      _createVNode(_component_v_list_item, {
                        title: "Account Settings",
                        "prepend-icon": "mdi-cog-outline"
                      }),
                      _createVNode(_component_v_list_item, {
                        title: "Dialog Examples",
                        "prepend-icon": "mdi-comment-processing-outline"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                sm: "3"
              }, {
                default: _withCtx(() => [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-caption text-medium-emphasis font-weight-bold mb-2" }, "USER INTERFACE", -1)),
                  _createVNode(_component_v_list, { density: "compact" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, {
                        title: "Typography",
                        "prepend-icon": "mdi-format-text"
                      }),
                      _createVNode(_component_v_list_item, {
                        title: "Accordion",
                        "prepend-icon": "mdi-view-parallel-outline"
                      }),
                      _createVNode(_component_v_list_item, {
                        title: "Alerts",
                        "prepend-icon": "mdi-alert-outline"
                      }),
                      _createVNode(_component_v_list_item, {
                        title: "Cards",
                        "prepend-icon": "mdi-credit-card-outline"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                sm: "3"
              }, {
                default: _withCtx(() => [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-caption text-medium-emphasis font-weight-bold mb-2" }, "RADIO & TABLES", -1)),
                  _createVNode(_component_v_list, { density: "compact" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, {
                        title: "Radio",
                        "prepend-icon": "mdi-radiobox-marked"
                      }),
                      _createVNode(_component_v_list_item, {
                        title: "Form Layouts",
                        "prepend-icon": "mdi-form-select"
                      }),
                      _createVNode(_component_v_list_item, {
                        title: "Table",
                        "prepend-icon": "mdi-table"
                      }),
                      _createVNode(_component_v_list_item, {
                        title: "Editor",
                        "prepend-icon": "mdi-square-edit-outline"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})